// Texty výpisu značek (brandsPage.js).
import { plural } from '../plural.js';

export default {
  perex:
    'Prodáváme jen značky, které si sami vyzkoušíme a umíme opravit, takže na náhradní díly a servis dosáhnete i po letech. U každé značky najdete celý její sortiment na skladě.',
  filterPlaceholder: 'Filtrovat značky',
  filterNone: 'Žádná značka tomuhle názvu neodpovídá.',
  ownEyebrow: 'Vlastní značka',
  ownTitle: 'Jipos Tools – nářadí, které máme pod rukama',
  ownText:
    'Vyvíjíme a dovážíme ji sami, takže známe každý díl. Náhradní díly držíme skladem a servis běží na naší prodejně v Bílině.',
  ownCtaPre: 'Zobrazit produkty ',
  seoTitle: 'Proč u nás najdete zrovna tyhle značky',
  seoText:
    'Sortiment stavíme kolem strojů, které umíme sami opravit. Každou značku držíme dlouhodobě, ne v jedné sezónní vlně. Díky tomu na náhradní díly dosáhnete i za pár let a servis nemusí čekat na dovoz.',
  seoPoints: [
    { title: 'Servis na prodejně', text: 'opravy a údržbu řešíme v Bílině, ne přes centrálu dodavatele.' },
    { title: 'Náhradní díly skladem', text: 'u hlavních značek držíme díly na běžné opotřebení.' },
    { title: 'Vyzkoušené v provozu', text: 'stroje si na prodejně osaháte naživo, poradíme podle reálného použití.' },
  ],
  adviceTitle: 'Hledáte konkrétní model?',
  adviceText: 'Řekněte nám značku a typ. Ověříme dostupnost i náhradní díly, i když stroj není ve výpisu.',
  adviceAction: 'Napsat poradně',
  /** 1 značka / 2–4 značky / 5+ značek */
  brandsWord: (n) => plural(n, ['značka', 'značky', 'značek']),
};
